<template>
    <div>
        <div class="simple-row">
            <div class="left">
                <a class="swb-btn swb-btn-small" @click="toPrint">打印</a>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>验收单信息</span>
            <div class="shrink-tab fr" :class="showPurchReceiptFlag? 'current': ''" @click="doShowPurchReceipt()">
                <span>{{ showPurchReceiptFlag ? '隐藏' : '展开' }}</span>
                <i :class="showPurchReceiptFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showPurchReceiptFlag">
            <div class="simple-form">
                <div class="form-group">
                    <div class="form-label">
                        <label>标题</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.title || '无' }}</span>
                    </div>
                </div>
            </div>
            <div class="simple-form flex col-4">
                <div class="form-group">
                    <div class="form-label">
                        <label>验收单号</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.innerNo || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>记账凭证号</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.reservedNo || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>买家公司编码</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.buyerRealComCode || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>买家公司名称</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.buyerRealComName || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>请购部门/门店</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.recvComName || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>成本中心</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.costCenterCode || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>卖家标识</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.buyerInnerSellerCode || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>卖家名称</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.sellerName || '' }}</span>
                    </div>
                </div>
                <div class="form-group" v-if="!isReturn">
                    <div class="form-label">
                        <label>订货日期</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.orderDate }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>{{ isReturn ? '退货' : '收货' }}日期</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.recvDate }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>单据创建时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.createTime }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>验收生凭时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.ledgerTime || '' }}</span>
                    </div>
                </div>
                <div class="form-group" v-if="purchReceipt.pullBackNo != null && purchReceipt.pullBackNo != ''">
                    <div class="form-label">
                        <label>已冲销</label>
                    </div>
                    <div class="form-value">
                        <span v-if="purchReceipt.pulledBack">是</span>
                        <span v-else>否</span>
                    </div>
                </div>
                <div class="form-group" v-if="purchReceipt.pullBackNo != null && purchReceipt.pullBackNo != ''">
                    <div class="form-label">
                        <label>冲销原因</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.rejectCause || '' }}</span>
                    </div>
                </div>
                <div class="form-group" v-if="purchReceipt.pullBackNo != null && purchReceipt.pullBackNo != ''">
                    <div class="form-label">
                        <label>冲销单号</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.pullBackNo || '' }}</span>
                    </div>
                </div>
                <div class="form-group" v-if="purchReceipt.pullBackNo != null && purchReceipt.pullBackNo != ''">
                    <div class="form-label">
                        <label>冲销审批状态</label>
                    </div>
                    <div class="form-value">
                        <span v-if="purchReceipt.pulledBackApplyState == 0">待申请</span>
                        <span v-else>{{ auditStateMap[purchReceipt.pulledBackAuditState] }}</span>
                    </div>
                </div>
                <div class="form-group" v-if="purchReceipt.pullBackNo != null && purchReceipt.pullBackNo != ''">
                    <div class="form-label">
                        <label>冲销凭证号</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.revokeReservedNo || '无' }}</span>
                    </div>
                </div>
                <div class="form-group" v-if="purchReceipt.pullBackNo != null && purchReceipt.pullBackNo != ''">
                    <div class="form-label">
                        <label>冲销生凭时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.revokeLedgerTime || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>已作废</label>
                    </div>
                    <div class="form-value">
                        <span v-if="purchReceipt.invalid">是</span>
                        <span v-else>否</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>作废原因</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.invalidCause || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>收货人</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.recvCreatorName || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>审核人</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.auditorName || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>发票类型</label>
                    </div>
                    <div class="form-value">
                        <span>{{ invoiceTypeMap[purchReceipt.invoiceType] }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>是否抵扣税</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.taxOffset ? '是' : '否' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>税率(%)</label>
                    </div>
                    <div class="form-value">
                        <span>{{ parseFloat(purchReceipt.taxRate || 0).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>锁帐未生凭</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.fiscalSspFlag ? '是' : '否' }}</span>
                    </div>
                </div>
                <div class="form-group" v-if="!purchReceipt.jointInvokeDone && purchReceipt.jointInvokeErrMsg != null">
                    <div class="form-label">
                        <label>对接推送失败原因</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.jointInvokeErrMsg || '' }}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="!isReturn">
            <div class="content-caption dashed">
                <span>订货验收信息</span>
                <div class="shrink-tab fr" :class="showGoodsItemListFlag? 'current': ''" @click="doShowGoodsItemList()">
                    <span>{{ showGoodsItemListFlag ? '隐藏' : '展开' }}</span>
                    <i :class="showGoodsItemListFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
                </div>
            </div>
            <template v-if="showGoodsItemListFlag">
                <div class="table-layout" v-if="purchReceipt.goodsItemList != null && purchReceipt.goodsItemList.length > 0">
                    <el-table :data="purchReceipt.goodsItemList" border style="width: 100%" maxHeight="400" ref="dataTable" :summary-method="getGoodsItemSum" show-summary>
                        <el-table-column prop="assetDefNo" label="资产定义编码"></el-table-column>
                        <el-table-column prop="assetDefName" label="资产定义名称"></el-table-column>
                        <el-table-column align="left" prop="assetNature" label="资产属性" width="100" fixed="left" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ assetNatureMap[rows.row.assetNature] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="quantity" label="验收数量" width="120" align="right"></el-table-column>
                        <el-table-column prop="wtxPrice" label="含税单价(元)" width="120" align="right">
                            <template slot-scope="rows">
                                <span v-if="rows.row.wtxPrice != null">{{ rows.row.wtxPrice.toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="taxRate" label="税率(%)" width="120" align="right">
                            <template slot-scope="rows">
                                <span v-if="rows.row.taxRate != null">{{ rows.row.taxRate.toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ntxPrice" label="未税单价(元)" width="120" align="right">
                            <template slot-scope="rows">
                                <span v-if="rows.row.ntxPrice != null">{{ rows.row.ntxPrice.toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="wtxAmount" label="含税总额(元)" width="120" align="right">
                            <template slot-scope="rows">
                                <span v-if="rows.row.wtxAmount != null">{{ rows.row.wtxAmount.toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ntxAmount" label="未税总额(元)" width="120" align="right">
                            <template slot-scope="rows">
                                <span v-if="rows.row.ntxAmount != null">{{ rows.row.ntxAmount.toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100" prop="taxRate" label="税额小计(元)">
                            <template slot-scope="rows">
                                <span>{{ parseFloat((rows.row.wtxAmount || 0) - parseFloat(rows.row.ntxAmount)).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </template>
        </template>
        <div class="content-caption dashed" v-if="purchReceipt.auditState == 1">
            <span>其他费用</span>
            <div class="shrink-tab fr" :class="showReceiptFeeFlag? 'current': ''" @click="doShowReceiptFee()">
                <span>{{ showReceiptFeeFlag ? '隐藏' : '展开' }}</span>
                <i :class="showReceiptFeeFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showReceiptFeeFlag && purchReceipt.auditState == 1">
            <el-table ref="multipleTable" :data="purchReceipt.feeItemList" border tooltip-effect="dark" :summary-method="getFeeItemSum" show-summary style="width: 100%" maxHeight="400">
                <el-table-column align="center" prop="feeType" label="费用类型" width="150" fixed show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span>{{ purchFeeTypeMap[rows.row.feeType] }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="name" label="名称" fixed show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="brandName" label="品牌" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="modelSpec" label="规格" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="unit" width="60" label="单位"></el-table-column>
                <el-table-column prop="price" align="right" width="120" label="单价(元)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.price != null">{{ rows.row.price.toFixed(2) }}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="quantity" width="120" label="数量"></el-table-column>
                <el-table-column prop="amount" align="right" width="120" label="小计(元)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.amount != null">{{ rows.row.amount.toFixed(2) }}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>
            </el-table>
        </template>
        <div class="content-caption dashed">
            <span>验收条目</span>
            <div class="shrink-tab fr" :class="showDeviceItemFlag? 'current': ''" @click="doShowDeviceItem()">
                <span>{{ showDeviceItemFlag ? '隐藏' : '展开' }}</span>
                <i :class="showDeviceItemFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showDeviceItemFlag">
            <div class="table-layout" v-if="purchReceipt.itemList != null && purchReceipt.itemList.length > 0">
                <el-table :data="purchReceipt.itemList" border maxHeight="400" ref="dataTable" tooltip-effect="dark" :summary-method="getDevcItemSum" show-summary style="width: 100%">
                    <el-table-column align="left" prop="devcDefNo" label="资产定义编码" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="innerCode" label="资产编号" width="160" fixed show-overflow-tooltip>
                        <template slot-scope="rows">
                            <a class="table-cell-link" @click="viewAssetInfo(rows.row);" v-if="!rows.row.invalid">{{ rows.row.innerCode }}</a>
                            <span v-else>{{ rows.row.innerCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="goodsTitle" label="资产名称" width="200" fixed show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" prop="assetNature" label="资产属性" width="120" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span>{{ assetNatureMap[rows.row.assetNature] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="catName" label="资产分类" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="brandName" label="资产品牌" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column align="right" prop="quantity" width="100" label="数量"></el-table-column>
                    <el-table-column align="center" prop="theUnit" min-width="50" label="单位"></el-table-column>
                    <el-table-column prop="wtxPrice" align="right" width="120" label="含税单价(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.wtxPrice != null">{{ rows.row.wtxPrice.toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxRate" align="right" width="120" label="税率(%)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.taxRate != null">{{ rows.row.taxRate.toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ntxPrice" align="right" width="120" label="未税单价(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.ntxPrice != null">{{ rows.row.ntxPrice.toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="wtxAmount" width="100" label="含税小计(元)">
                        <template slot-scope="rows">
                            <span class="font-red" v-if="rows.row.wtxAmount != null">{{ rows.row.wtxAmount.toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="ntxAmount" width="120" label="未税小计(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.ntxAmount != null">{{ rows.row.ntxAmount.toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="taxAmount" width="120" label="税额小计(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.taxAmount != null">{{ rows.row.taxAmount.toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="assetType" width="150" label="管理方式" v-if="showBizUnitWarehouse">
                        <template slot-scope="rows">
                            <span>{{ assetTypeMap[rows.row.assetType] }}</span>
                        </template>
                    </el-table-column>
                    <!--                    <el-table-column prop="initWtxPrice" align="right" width="120" label="含税原单价(元)">-->
                    <!--                        <template slot-scope="rows">-->
                    <!--                            <span v-if="rows.row.initWtxPrice != null">{{ rows.row.initWtxPrice.toFixed(2) }}</span>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <!--                    <el-table-column align="right" prop="logisFee" width="100" label="物流小计(元)" v-if="purchFeeNames.contains('LogisFee')">-->
                    <!--                        <template slot-scope="rows">-->
                    <!--                            <span v-if="rows.row.logisFee != null">{{ rows.row.logisFee.toFixed(2) }}</span>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <!--                    <el-table-column align="right" prop="asmblFee" width="100" label="组装小计(元)" v-if="purchFeeNames.contains('AsmblFee')">-->
                    <!--                        <template slot-scope="rows">-->
                    <!--                            <span v-if="rows.row.asmblFee != null">{{ rows.row.asmblFee.toFixed(2) }}</span>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <!--                    <el-table-column align="right" prop="setupFee" width="100" label="安装小计(元)" v-if="purchFeeNames.contains('SetupFee')">-->
                    <!--                        <template slot-scope="rows">-->
                    <!--                            <span v-if="rows.row.setupFee != null">{{ rows.row.setupFee.toFixed(2) }}</span>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <!--                    <el-table-column align="right" prop="tearFee" width="100" label="拆除小计(元)" v-if="purchFeeNames.contains('TearFee')">-->
                    <!--                        <template slot-scope="rows">-->
                    <!--                            <span v-if="rows.row.tearFee != null">{{ rows.row.tearFee.toFixed(2) }}</span>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <!--                    <el-table-column align="right" prop="toDoorFee" width="100" label="上门小计(元)" v-if="purchFeeNames.contains('toDoorFee')">-->
                    <!--                        <template slot-scope="rows">-->
                    <!--                            <span v-if="rows.row.toDoorFee != null">{{ rows.row.toDoorFee.toFixed(2) }}</span>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <!--                    <el-table-column align="right" prop="repairFee" width="100" label="维修小计(元)" v-if="purchFeeNames.contains('RepairFee')">-->
                    <!--                        <template slot-scope="rows">-->
                    <!--                            <span v-if="rows.row.repairFee != null">{{ rows.row.repairFee.toFixed(2) }}</span>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <!--                    <el-table-column align="right" prop="otherFee" width="140" label="其他杂费小计(元)" v-if="purchFeeNames.contains('OthersFee')">-->
                    <!--                        <template slot-scope="rows">-->
                    <!--                            <span v-if="rows.row.otherFee != null">{{ rows.row.otherFee.toFixed(2) }}</span>-->
                    <!--                            <span v-else>0.00</span>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <!--                    <el-table-column align="right" prop="xtraFee" width="140" label="分摊费用总计(元)" v-if="(purchFeeNames || []).length > 0">-->
                    <!--                        <template slot-scope="rows">-->
                    <!--                            <span v-if="rows.row.xtraFee != null">{{ rows.row.xtraFee.toFixed(2) }}</span>-->
                    <!--                            <span v-else>0.00</span>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <!--                    <el-table-column align="center" prop="invoiceState" width="100" label="开票状态">-->
                    <!--                        <template slot-scope="rows">-->
                    <!--                            <span>{{ invoiceStateMap[rows.row.invoiceState] }}</span>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <!--                    <el-table-column align="left" prop="warehouseName" width="150" label="入库仓库" v-if="showBizUnitWarehouse">-->
                    <!--                        <template slot-scope="rows">-->
                    <!--                            <span>{{ rows.row.warehouseName }}</span>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->

                    <!--                    <el-table-column align="center" prop="customized" width="100" label="定制商品">-->
                    <!--                        <template slot-scope="rows">-->
                    <!--                            <span>{{ rows.row.customized ? '是' : '否' }}</span>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                </el-table>
            </div>
        </template>
        <div class="content-caption dashed" v-if="purchReceipt.pullBackNo != null && purchReceipt.pullBackNo != '' && purchReceipt.pulledBackOuterAuditFlag">
            <span>冲销审批记录</span>
            <div class="shrink-tab fr" :class="showOaAuditBackFlag ? 'current': ''" @click="doShowOaAuditBackInfo()">
                <span>{{ showOaAuditBackFlag ? '隐藏' : '展开' }}</span>
                <i :class="showOaAuditBackFlag ? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showOaAuditBackFlag && purchReceipt.pullBackNo != null && purchReceipt.pullBackNo != '' && purchReceipt.pulledBackOuterAuditFlag">
            <swb-oa-audit-rec-list bizTypeCode="retailer.assets.purch.receipt" :bizVoucherNo="purchReceipt.innerNo" :auditSeqNo="purchReceipt.pulledBackAuditSeqNo" ref="swb_oa_audit_rec_list"></swb-oa-audit-rec-list>
        </template>

        <div class="content-caption dashed">
            <span>附件信息</span>
        </div>
        <div class="file-view-list" v-if="fileList != null && fileList.length > 0">
            <div class="file-view-header">
                <div class="file-name">名称</div>
                <div class="file-opera">操作</div>
            </div>
            <template v-for="(fileInfo, index) in fileList">
                <swb-file-item-li :trackKey="index" :fileName="fileInfo.name" :fileBrowseUrl="fileInfo.fileBrowseUrl" :fileDownloadUrl="fileInfo.fileBrowseUrl" :fileUuid="fileInfo.fileUuid" :deletable="false"></swb-file-item-li>
            </template>
        </div>
    </div>
</template>
<script>
import { Utils } from '../../app.base'
import { MsgBox, Routes, Vue } from '../../app.vues'
import { assetFiscalInfoDlg } from '../retailer/dialog'
import { getMerchantBizParam } from '../asset/assetMain'
import appConf from '../../app.conf';

import receiptApi from '../../api/receipt'
import merchantComnApi from '../../api/merchtComn'
import goodsOrderApi from '../../api/goodsOrder'

import AuditBpRecsList from '../oaAudit/AuditBpRecsList.vue';
import SwbGoodsOrderList from '../order/GoodsOrderList';
import SwbContractGoodsOrderList from '../order/ContractGoodsOrderList';

Vue.regist(AuditBpRecsList);

Routes.add(SwbGoodsOrderList);

Routes.add(SwbContractGoodsOrderList);

export default {
    name: 'swb-purch-receipt-tmp-detail',
    desc: '临采验收单详情',
    props: ['id', 'no', 'isReturn'],      // isReturn： 是否为退货验收单
    data: function () {
        return {
            purchReceipt: {},
            fileList: [],
            //
            invoiceStateMap: getEnumMap('invoiceState', 'value2text'),
            invoiceTypeMap: getEnumMap('invoiceType', 'value2text'),
            assetNatureMap: getEnumMap('assetNature', 'value2text'),
            purchFeeTypeMap: getEnumMap('purchFeeType', 'value2text'),
            assetTypeMap: getEnumMap('assetType', 'value2text'),
            auditStateMap: getEnumMap('auditState', 'value2text'),
            requireBackConfirm: false,
            //
            showReceiptFeeFlag: true,
            showDeviceItemFlag: true,
            showPurchReceiptFlag: true,
            showGoodsItemListFlag: true,
            showBizUnitWarehouse: false,
            showOaAuditBackFlag: true,
            purchFeeNames: []
        }
    },
    //
    updated() {
        this.$nextTick(() => {
            this.$refs.dataTable.doLayout()
        })
    },
    created: function () {
        let self = this;
        getMerchantBizParam('show.biz.unit.warehouse', function (result) { // 显示门店/机构的仓库： {}
            self.showBizUnitWarehouse = Utils.isTrue(result);
        });
        this.checkRequireBackConfirm();
        if(!Utils.isNoB(this.id) || !Utils.isNoB(this.no)) {
            this.getpurchReceiptDetail();
        }
    },
    methods: {
        // render 事件
        renderTaxRate(h, {column}) {
            return h(
                'div',
                [
                    h('span', column.label),
                    h('el-tooltip', {
                        class: 'item fr',
                        props: {
                            effect: 'light',
                            placement: 'top'
                        }
                    }, [
                        h('span', {
                            class: 'font-black',
                            style: 'white-space: pre-wrap',
                            slot: 'content'
                        }, '指合同签约时，约定的预定税率。'),
                        h('span', {
                            style: 'col-title-tooltip-wrapper'
                        }, [
                            h('a', {
                                class: 'el-icon-warning col-title-tooltip',
                                style: 'color:red;margin-left:5px;'
                            })
                        ])
                    ])
                ],
            );
        },
        // 获取回溯确认业务参数
        checkRequireBackConfirm: function () {
            let self = this;
            let postData = {
                code: 'purch.accecpt.require.back.confirm'
            };
            merchantComnApi.getMerchantBizParamValue(postData, function (result) {
                if(result.type == 'info') {
                    self.requireBackConfirm = Utils.isTrue(result.data);
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },
        // 查看购置验收单详情
        getpurchReceiptDetail: function () {
            let self = this;
            //
            let postData = {};
            postData.id = self.id;
            postData.no = self.no;
            let msgBoxDlg = MsgBox.loading();
            receiptApi.getPurchReceiptInfo(postData, function (result) {
                msgBoxDlg.close();
                if(result.type == 'info') {
                    let purchReceipt = result.data;
                    let feeItemList = purchReceipt.feeItemList || [];
                    if(Utils.isNoB(feeItemList) || feeItemList.length <= 0) {
                        self.showReceiptFeeFlag = false;
                    }
                    self.fileList = purchReceipt.fileList || [];
                    self.purchReceipt = Utils.merge({}, purchReceipt);
                    //
                    let purchFeeNames = [];
                    for(let i = 0; i < feeItemList.length; i++) {
                        let feeItem = feeItemList[i];
                        let feeName = getEnumInfoWith('purchFeeType', 'value', feeItem.feeType).name;
                        if(!purchFeeNames.contains(feeName)) {
                            purchFeeNames.push(feeName);
                        }
                    }
                    self.purchFeeNames = Utils.merge([], purchFeeNames);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 查看资产信息
        viewAssetInfo: function (row) {
            let params = {
                innerCode: row.innerCode,
                assetType: row.assetType
            };
            assetFiscalInfoDlg(params);
        },
        // 隐藏、展开
        doShowReceiptFee: function () {
            this.showReceiptFeeFlag = !this.showReceiptFeeFlag;
        },
        // 隐藏、展开
        doShowDeviceItem: function () {
            this.showDeviceItemFlag = !this.showDeviceItemFlag;
        },
        // 隐藏、展开
        doShowPurchReceipt: function () {
            this.showPurchReceiptFlag = !this.showPurchReceiptFlag;
        },
        // 隐藏、展开
        doShowGoodsItemList: function () {
            this.showGoodsItemListFlag = !this.showGoodsItemListFlag;
        },
        // 展开/隐藏
        doShowOaAuditBackInfo: function () {
            this.showOaAuditBackFlag = !this.showOaAuditBackFlag;
        },
        getGoodsItemSum(param) {
            const {columns, data} = param;
            const sums = [];
            columns.forEach((column, index) => {
                if(index === 0) {
                    sums[index] = '合计';
                    return;
                }
                let flag = true;
                let quantityFlag = false;
                let values = data.map(item => Number(item[column.property]));
                //
                if(column.property == 'quantity') {
                    values = data.map(item => Number(item['quantity']));
                    quantityFlag = true;
                } else if(column.property == 'ntxAmount') {
                    values = data.map(item => Number(item['ntxAmount']));
                } else if(column.property == 'wtxAmount') {
                    values = data.map(item => Number(item['wtxAmount']));
                } else {
                    flag = false;
                }
                if(flag && !values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if(quantityFlag) {
                            if(!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        } else {
                            if(!isNaN(value)) {
                                return (parseFloat(prev) + parseFloat(curr)).toFixed(2);
                            } else {
                                return parseFloat(prev).toFixed(2);
                            }
                        }
                    }, 0);
                    if(quantityFlag) {
                        sums[index];
                    } else {
                        sums[index] += ' 元';
                    }
                } else {
                    sums[index] = '-';
                }
            });
            return sums;
        },
        // 收货验收信息合计
        getGoodsOrderItemSum(param) {
            const {columns, data} = param;
            const sums = [];
            columns.forEach((column, index) => {
                if(index === 0) {
                    sums[index] = '合计';
                    return;
                }
                let flag = true;
                let quantityFlag = false;
                let values = data.map(item => Number(item[column.property]));
                //
                let quantity = data.map(item => Number(item['quantity']));
                let receiptQuantity = data.map(item => Number(item['receiptQuantity']));
                if(column.property == 'priceZ') {   // 订购含税总金额
                    let prices = data.map(item => Number(item['price']));
                    let datas = [];
                    for(let i = 0; i < prices.length; i++) {
                        let price = prices[i];
                        datas.push((quantity[i] * price));
                    }
                    values = Utils.merge([], datas);
                } else if(column.property == 'ntxPriceZ') {
                    let prices = data.map(item => Number(item['ntxPrice']));
                    let datas = [];
                    for(let i = 0; i < prices.length; i++) {
                        let price = prices[i];
                        datas.push((quantity[i] * price));
                    }
                    values = Utils.merge([], datas);
                } else if(column.property == 'receiptNtxPriceZ') {
                    let prices = data.map(item => Number(item['receiptNtxPrice']));
                    let datas = [];
                    for(let i = 0; i < prices.length; i++) {
                        let price = prices[i];
                        datas.push((receiptQuantity[i] * price));
                    }
                    values = Utils.merge([], datas);
                } else if(column.property == 'receiptPriceZ') {
                    let prices = data.map(item => Number(item['receiptPrice']));
                    let datas = [];
                    for(let i = 0; i < prices.length; i++) {
                        let price = prices[i];
                        datas.push((receiptQuantity[i] * price));
                    }
                    values = Utils.merge([], datas);
                } else if(column.property == 'quantity' || column.property == 'receiptQuantity') {
                    //
                    quantityFlag = true;
                } else {
                    flag = false;
                }
                if(flag && !values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if(quantityFlag) {
                            if(!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        } else {
                            if(!isNaN(value)) {
                                return (parseFloat(prev) + parseFloat(curr)).toFixed(2);
                            } else {
                                return parseFloat(prev).toFixed(2);
                            }
                        }
                    }, 0);
                    if(quantityFlag) {
                        sums[index];
                    } else {
                        sums[index] += ' 元';
                    }
                } else {
                    sums[index] = '-';
                }
            });
            return sums;
        },
        // 费用小计
        getFeeItemSum: function (param) {
            const {columns, data} = param;
            const sums = [];
            columns.forEach((column, index) => {
                if(index === 0) {
                    sums[index] = '合计';
                    return;
                }
                let flag = true;
                let quantityFlag = false;
                let values = data.map(item => Number(item[column.property]));
                if(column.property == 'price') {
                    values = data.map(item => Number(item['price']));
                } else if(column.property == 'amount') {
                    values = data.map(item => Number(item['amount']));
                } else {
                    flag = false;
                }
                if(flag && !values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if(quantityFlag) {
                            if(!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        } else {
                            if(!isNaN(value)) {
                                return (parseFloat(prev) + parseFloat(curr)).toFixed(2);
                            } else {
                                return parseFloat(prev).toFixed(2);
                            }
                        }
                    }, 0);
                    if(quantityFlag) {
                        sums[index];
                    } else {
                        sums[index] += ' 元';
                    }
                } else {
                    sums[index] = '-';
                }
            });
            return sums;
        },
        // 单品、批量
        getDevcItemSum: function (param) {
            const {columns, data} = param;
            const sums = [];
            columns.forEach((column, index) => {
                if(index === 0) {
                    sums[index] = '合计';
                    return;
                }
                let flag = true;
                let quantityFlag = false;
                let values = data.map(item => Number(item[column.property]));
                //
                if(column.property == 'quantity') {
                    values = data.map(item => Number(item['quantity']));
                    quantityFlag = true;
                } else if(column.property == 'ntxAmount') {
                    values = data.map(item => Number(item['ntxAmount']));
                } else if(column.property == 'wtxAmount') {
                    values = data.map(item => Number(item['wtxAmount']));
                } else if(column.property == 'xtraFee') {
                    values = data.map(item => Number(item['xtraFee']));
                } else if(column.property == 'logisFee') {
                    values = data.map(item => Number(item['logisFee']));
                } else if(column.property == 'asmblFee') {
                    values = data.map(item => Number(item['asmblFee']));
                } else if(column.property == 'setupFee') {
                    values = data.map(item => Number(item['setupFee']));
                } else if(column.property == 'tearFee') {
                    values = data.map(item => Number(item['tearFee']));
                } else if(column.property == 'toDoorFee') {
                    values = data.map(item => Number(item['toDoorFee']));
                } else if(column.property == 'repairFee') {
                    values = data.map(item => Number(item['repairFee']));
                } else {
                    flag = false;
                }
                if(flag && !values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if(quantityFlag) {
                            if(!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        } else {
                            if(!isNaN(value)) {
                                return (parseFloat(prev) + parseFloat(curr)).toFixed(2);
                            } else {
                                return parseFloat(prev).toFixed(2);
                            }
                        }
                    }, 0);
                    if(quantityFlag) {
                        sums[index];
                    } else {
                        sums[index] += ' 元';
                    }
                } else {
                    sums[index] = '-';
                }
            });
            return sums;
        },
        toPrint() {
            let collapsedBlocks = [];
            // 其他费用 table
            if(!this.showReceiptFeeFlag) {
                collapsedBlocks.push('feeItems');
            }
            // 收货验收条目 table
            if(!this.showDeviceItemFlag) {
                collapsedBlocks.push('devcItems');
            }
            // 购置验收 表单
            if(!this.showPurchReceiptFlag) {
                collapsedBlocks.push('mainInfo');
            }
            // 验收商品条目
            if(!this.showGoodsItemListFlag) {
                collapsedBlocks.push('goodsItemList');
            }
            let purchReceipt = this.purchReceipt;
            let url = '/voucher/print/jsp';
            let params = {
                bizType: 'biz.proof.lincai.yanshou',
                voucherId: purchReceipt.id,
                collapsedBlocks: collapsedBlocks.join(',')

            };
            let printUrl = Utils.makeUrl(getAppUrl(url), params, true);
            Utils.setPageUrl(printUrl, '_blank');
        },
        toOrderPage() {
            let purchReceipt = this.purchReceipt;
            let data = {no: purchReceipt.orderNo};
            let path = SwbGoodsOrderList.path;
            if(purchReceipt.contractId != null && purchReceipt.contractId != -1) {
                path = SwbContractGoodsOrderList.path;
            }
            let hashUrl = Utils.makeUrl(path, data);
            appConf.openPageRouteUrl(null, '/bench/home', hashUrl)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/receipt/PurchReceiptTmpDetail.vue